<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { UserStore, UsersStore }  from '../stores'

    import UsersService from '../$services/users.service'
    
    import Form from '../$components/form.svelte'
    import InputPassword from '../$components/input.password.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {}
    
    async function updateUserPassword() {
    
        loading = true
        const resp = await UsersService.updateUserPassword($UserStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        UserStore.set(resp.data)
        UsersStore.replace(resp.data)

        toast({message: 'Contraseña actualizada', type: 'is-success'})
        dispatch('updated', resp.data)
    }

</script>

<Form on:submit={updateUserPassword} on:canceled {loading} >

    <div class="columns">
        <div class="column">
            <InputPassword bind:value={data.password} label="Contraseña" />
        </div>
    </div>
</Form>